import React, { useState, useEffect, FC, SVGProps } from 'react';
import { pascalCase } from 'change-case';

export const AssetsNames = [
  'action-error',
  'action-loading-clock',
  'action-not-found',
  'action-success',
  'document-send-success',
  'sicredi-icon',
  'sicredi-icon-negative',
  'sicredi-logo',
  'sicredi-logo-negative',
  'padlock-closed',
  'product-signed',
  'document-sent',
  'gratitude-feedback',
  'verification-email',
  'request-under-review',
  'reminder-and-pending',
  'wait',
  'generic-system-error',
  'support',
  'house',
  'search',
  'council',
  'relationship',
  'unity',
  'padlock',
  'bond-of-association',
  'account-manager',
  'sent-email',
  'phone-selfie',
  'agency-redirection',
  'error-temporary-account-access',
  'rejected-proposal',
  'sicredi-icon-104',
  'sicredi-icon-40',
  'sicredi-icon-32',
  'sicredi-icon-24',
  'sicredi-icon-16',
  'sicredi-icon-negative-104',
  'sicredi-icon-negative-40',
  'sicredi-icon-negative-32',
  'sicredi-icon-negative-24',
  'sicredi-icon-negative-16',
  'sicredi-logo-104',
  'sicredi-logo-40',
  'sicredi-logo-32',
  'sicredi-logo-24',
  'sicredi-logo-16',
  'sicredi-logo-negative-104',
  'sicredi-logo-negative-40',
  'sicredi-logo-negative-32',
  'sicredi-logo-negative-24',
  'sicredi-logo-negative-16',
  'document',
  'personal-info',
  'session-expired',
  'whatsapp',
  'document-destructive-action-completed',
  'back-of-cnh',
  'front-of-cnh',
  'back-of-rg',
  'front-of-rg',
  'back-of-cin',
  'front-of-cin',
  'back-of-identity',
  'front-of-identity',
  'caption-of-document',
  'money-note',
  'to-update',
  'pix-sent-successfully',
  'pix-key-request-failed',
  'password-registration',
  'page-not-found',
  'notification-warning',
  'notification-success',
  'invalid-photo',
  'identity-analysis',
  'identification',
  'document-analysis',
  'capture-failure',
  'access-not-permitted',
] as const;

export interface AssetProps extends SVGProps<SVGSVGElement> {
  name: typeof AssetsNames[number];
}

/**
 * @function Asset
 * @description Asset Component that can be used to render assets from Sicredi Images Database
 */
const Asset: FC<AssetProps> = ({ name, ...rest }) => {
  const [AssetComponent, setAssetComponent] = useState<React.ComponentType<SVGProps<SVGSVGElement>> | null>(null);

  const importAsset = async (): Promise<void> => {
    try {
      const assetName = pascalCase(name).replace('_', '');
      // @ts-ignore
      const { [assetName]: asset } = await import(`@sicredi/react-assets/dist/images/index.esm.js`);
      setAssetComponent(() => asset);
    } catch (err) {
      console.error(`O asset "${name}" que você está tentando importar não foi encontrado na biblioteca de assets com este nome`);
      setAssetComponent(null);
    }
  };

  useEffect(() => {
    importAsset();
  }, [name]);

  if (!AssetComponent) {
    return null;
  }

  return <AssetComponent data-testid="svg-asset" {...rest} />;
};

export default Asset;
